
import { TrustAPI } from "@/shared/modules/trust-api";
import { ComplianceForm, PartAFormDeclaration } from "@/shared/modules/typescript-trustapi-client/models";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { AuthorizedUser } from "@/trust-atcs-app/models/authorized-user";
import { FormPartAData } from "@/trust-atcs-app/models/form-part-a-data";
import store from "@/trust-atcs-app/store";
import { EventEmitter } from "events";
import { Emit, Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';

@Options({
  components: {},
  mixins: [FormatDateTimeMixin],
})
export default class FormPartADeclaration extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop()
  private formPartAData!: FormPartAData;

  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Emit('update:isSectionLoading')
  @Emit('validForm')

  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  private ai = new AppInsights;
  private loadingContent = false;
  private errorLoadingContent = false;

  private declarationContent: PartAFormDeclaration = null as any;

  created(): void {
    this.loadDeclarationContent();
  }

  private async loadDeclarationContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.PartAFormApi?.apiV2PartAFormGetDeclarationPost({
        complianceFormId: this.complianceFormA.id,
        updatingKey: this.updatingKey,
      });

      this.declarationContent = resp.data.data as PartAFormDeclaration;
      this.formPartAData.declarationDetails = this.declarationContent;
      setTimeout(() => {
        this.$emit('validForm', this.validForm());
      }, 100);
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error loading content');
      this.errorLoadingContent = true;
    } finally {
      this.loadingContent = false;
    }
  }

  private validForm(): boolean {
    return this.formPartAData.declarationDetails?.isPrincipal && this.formPartAData.declarationDetails?.hasTrustCoordinator;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get complianceFormA(): ComplianceForm {
    return store.getters.getSelectedComplianceFormA;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  get completer(): string {
    try {
      return this.userAccount?.user?.firstName + ' ' + this.userAccount?.user?.lastName;
    } catch (err) {
      console.log(err);
      return '';
    }
  }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

}

